<template>
  <div class="pageBox">
    <el-pagination
      @current-change="handleCurrentChange"
      :pager-count="5"
      :page-size="PagingInfo.ItemsPerPage"
      
      background
      layout="prev, pager, next"
      :total="PagingInfo.TotalItems"
      :current-page.sync="PagingInfo.CurrentPage"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: ["PagingInfo"],
  watch: {
    PagingInfo: {
      handler(newValue, oldValue) {
        // console.log('oldValue',oldValue);
        // this.CurrentPage = newValue.CurrentPage
        // this.$forceUpdate()
      },
    },
    deep: true,
  },
  methods: {
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.$emit("pageChange", val);
      sessionStorage.setItem('currentPage', val);
      /* let path = this.$route.path;
      this.$router.push({
        path:`${path}?page=${val}`,
      }); */
    },
    changePage(page) {
      if (
        page != this.PagingInfo.CurrentPage &&
        page <= this.PagingInfo.TotalPages &&
        page >= 1
      ) {
        this.$emit("pageChange", page);
      }
    },
  },
  mounted() {
    // this.$forceUpdate()
  },
};
</script>

<style lang="scss">
.pageBox {
  padding: 40px 0;
  text-align: center;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d71820 !important;
  border-color: #d71820 !important;
}
.btn-prev span,
.btn-next span {
  font-size: 18px !important;
  color: #000;
  &:hover {
    color: #d71820;
  }
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #d71820 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #fff !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #fff !important;
  border: 1px solid #ddd;
  border-radius: 0;
}
</style>
